const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
import { MediaPlaceholder, BlockIcon, BlockControls, MediaUploadCheck, MediaUpload, AlignmentToolbar, InspectorControls, PanelColorSettings, FontSizePicker} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton, PanelBody, RangeControl, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, SelectControl, TextControl, ToggleControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl} from "@wordpress/components";
import {fontfamilylist} from "./lib/fontfamilylist.js";
registerBlockType('spice-blocks/spice-gallery',{
    title:__('Image Gallery','spice-blocks'),
    category:'spice-blocks',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path stroke="#09A223" fill="#09A223" d="M10 15c0-.552.448-1 1.001-1s.999.448.999 1-.446 1-.999 1-1.001-.448-1.001-1zm6.2 0l-1.7 2.6-1.3-1.6-3.2 4h10l-3.8-5zm7.8-5v14h-18v-14h18zm-2 2h-14v10h14v-10zm-6.462-9.385l2.244 5.385h2.167l-3.334-8-16.615 6.923 4 9.663v-5.265l-1.384-3.321 12.922-5.385z"></path></svg>,
    keywords: [
        __('Spice Image Gallery','spice-blocks'),
        __('Gallery','spice-blocks'),
        __('Image Gallery','spice-blocks')
     ],
    example: {
		"attributes": {
			heading: __('Spice Gallery','spice-blocks')
		}
	},
    attributes: {
        uniqueId:{
            type:'string'
        },
        alignment: {
            type: 'string',
            default: 'center'
        },
        previewImg: {
			type: 'string'
		},
        images: {
            type:'array',
            default: []
        },
        gutterMargin:{
            type:'number',
            default:32
        },
        colLayout:{
            type:'number',
            default:3
        },
        imageBorderRadius:{
            type:'number',
            default:5
        },
        sectionMargin: {
            default: {
                top: '0px',
                right: 'auto',
                bottom: '0px',
                left: 'auto'
            }
        },
        titlePaddings: {
            default: {
                top: '0',
                right: '0',
                bottom: '2px',
                left: '2px'
            }
        },
        sectionPaddings: {
            default: {
                top: '4px',
                right: '0',
                bottom: '14px',
                left: '0'
            }
        },
        hshadow: {
            type: 'number',
            default: 0
        },
        vshadow: {
            type: 'number',
            default: 0
        },
        blurshadow: {
            type: 'number',
            default: 0
        },
        animation:{
            type:'string',
            default:''
        },
        durations:{
            type:'string',
            default:' '
        },
        delay:{
            type:'string',
        },
        displayCaption:{
            type:'boolean',
            default:true
        },
        hidedesktop:{
            type:'boolean',
            default:true
        },
        hidetablet:{
            type:'boolean',
            default:true
        },
        hidemobile:{
            type:'boolean',
            default:true
        },
        titleColor:{
            type:'string',
            default:'#fff'
        },
        backgroundColor:{
            type:'string',
            default:'rgba(0, 0, 0, 0.7)'
        },
        shadowColor:{
            type:'string',
            default:'#777777'
        },
        overlayOpacity:{
            type:'number',
            default:0.6
        },
        titleSize:{
            type:'string',
            default:'24px'
        },
        titleFamily:{
            type:'string',
            default:'Montserrat'
        },
        titleWeight:{
            type:'string',
            default:700
        },
        titleHeight:{
            type:'number'
        },
        titleDecoration:{
            type:'string'
        },
        titleLetterSpacing:{
            type:'number'
        },
        titleTransform:{
            type:'string'
        },
        addclass:{
            type:'string',
        },
        customcss:{
            type:'string',
        }
    },
    edit: function ( props ){
            const { attributes, setAttributes,clientId } = props;
            const hasImages = props.attributes.images.length > 0;
            const { uniqueId, colLayout, gutterMargin, imageBorderRadius, sectionMargin, titlePaddings, sectionPaddings, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, titleColor, backgroundColor, shadowColor, overlayOpacity, titleSize, titleFamily, titleWeight, titleHeight, titleTransform, titleDecoration, titleLetterSpacing, displayCaption, alignment, addclass, customcss} = attributes;
            const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
            const displaydesktop=(hidedesktop == false) ? 'gallery-hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'gallery-hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'gallery-hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
            // set unique ID
             setAttributes({ uniqueId: clientId.slice(0, 8), }); 

            if(titleFamily !=null){
                let url = 'https://fonts.googleapis.com/css2?family='+titleFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                 let link = document.createElement('link')
                  link.href = url;
                  link.rel = "stylesheet";
                  link.type =  "text/css";
                  
                  if ( jQuery("body").hasClass("site-editor-php") ) { 
                  jQuery('iframe').contents().find("head").append(link);
              }else{
                  document.head.appendChild(link);
              }
            }

            return([<>
                <InspectorControls>  
                    <PanelBody initialOpen={true} title={__('General Settings','spice-block')} className={'spice-block-side-margin'}>
                        <ToggleControl
                            label={__('Enable/Disable Caption','spice-blocks')}
                            checked={displayCaption}
                            onChange={(userVal) => setAttributes({ displayCaption: userVal })}
                            />
                        <RangeControl 
                            label={__('Column Layout','spice-blocks')}
                            value={colLayout}
                            onChange={(userVal) => props.setAttributes({colLayout:userVal})}
                            min={1}
                            max={4}
                            step={1}
                        />
                        <RangeControl 
                            label={__('Gutter Margin (px)','spice-blocks')}
                            value={gutterMargin}
                            onChange={(userVal) => props.setAttributes({gutterMargin:userVal})}
                            min={0}
                            max={30}
                            step={1}
                        />
                        <RangeControl 
                            label={__('Image Border Radius','spice-blocks')}
                            value={imageBorderRadius}
                            onChange={(userVal) => props.setAttributes({imageBorderRadius:userVal})}
                            min={0}
                            max={50}
                            step={1}
                        />
                        <PanelBody initialOpen={false} title={__('Spacing','spice-block')} className={'spice-panel-edit margin'}>
                            <BoxControl 
                                label={__('Section Margin','spice-blocks')}
                                values={sectionMargin}
                                sides={['top', 'right','bottom','left']}
                                allowReset={false}
                                inputProps={{ min: -300 }}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    sectionMargin:{
                                        top:userVal.top,
                                        right:userVal.right,
                                        bottom:userVal.bottom,
                                        left:userVal.left
                                    }
                                })}
                            />
                            <BoxControl 
                                label={__('Section Padding','spice-blocks')}
                                values={sectionPaddings}
                                sides={['top', 'right','bottom','left']}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    sectionPaddings:{
                                        top:userVal.top,
                                        right:userVal.right,
                                        bottom:userVal.bottom,
                                        left:userVal.left
                                    }
                                })}
					        /> 
                            <BoxControl 
                                label={__('Caption Padding','spice-blocks')}
                                values={titlePaddings}
                                sides={['top', 'bottom','left','right']}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) => setAttributes({
                                    titlePaddings:{
                                        top:userVal.top,
                                        right:userVal.right,
                                        bottom:userVal.bottom,
                                        left:userVal.left
                                    }
                                })}
					        />
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                            <SelectControl
                                label={__('Animation','spice-blocks')}
                                value={ animation }
                                options={ [
                                            { label: __('None','spice-blocks'), value: ' ' },
                                            { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                            { label: __('Flash','spice-blocks'), value: 'flash' },
                                            { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                            { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                            { label: __('Shake','spice-blocks'), value: 'shake' },
                                            { label: __('Swing','spice-blocks'), value: 'swing' },
                                            { label: __('Tada','spice-blocks'), value: 'tada' },
                                            { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                            { label: __('Jello','spice-blocks'), value: 'jello' },
                                            { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                            { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                            { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                            { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                            { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                            { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                            { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                            { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                            { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                            { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                            { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                            { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                            { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                            { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                            { label: __('Flip','spice-blocks'), value: 'flip' },
                                            { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                            { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                            { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                            { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                            { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                            { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                            { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                            { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                            { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                            { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                            { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                            { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                            { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                            { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                            { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                            { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                            { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                                        ] }
                                onChange={ (userVal) => setAttributes({ animation: userVal }) }					  
                            /> 
                            { animation !='' && (<> 
                            <SelectControl
                                label={__('Durations','spice-blocks')}
                                value={ durations }
                                options={ [
                                    { label: __('Normal','spice-blocks'), value: ' '    },
                                    { label: __('Slow','spice-blocks'),   value: 'slow' },
                                    { label: __('Fast','spice-blocks'),   value: 'fast' },
                                        ] }
                                onChange={ (userVal) => setAttributes({ durations: userVal }) }					  
                            />  
                            <TextControl
                                label={__('Delay(ms)','spice-blocks')}			    
                                value={delay}
                                onChange={(userVal) => setAttributes({ delay: userVal })}
                            />
                            </>)}
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>					
                            <ToggleControl
                                label={__('Enable/Disable on Desktop','spice-blocks')}
                                checked={hidedesktop}
                                onChange={(userVal) => setAttributes({ hidedesktop: userVal })}
                            />
                            <ToggleControl
                                label={__('Enable/Disable on Tablet','spice-blocks')}
                                checked={hidetablet}
                                onChange={(userVal) => setAttributes({ hidetablet: userVal })}
                            />
                            <ToggleControl
                                label={__('Enable/Disable on Mobile','spice-blocks')}
                                checked={hidemobile}
                                onChange={(userVal) => setAttributes({ hidemobile: userVal })}
                            />
                        </PanelBody>
                    </PanelBody> 
                    <PanelBody initialOpen={false} title={__('Box Shadow','spice-blocks')} className={'spice-block-side-margin'}>	
                        <RangeControl 
                            label={__('Horizontal Shadow(px)','spice-blocks')}			    
                            value={ hshadow}
                            onChange={(userVal) => setAttributes({ hshadow: userVal })}
                            min={0}
                            max={100}
                        />
                        <RangeControl 
                            label={__('Vertical Shadow(px)','spice-blocks')}			    
                            value={ vshadow} onChange={(userVal) => setAttributes({ vshadow: userVal })}
                            min={0}
                            max={100}
                        />	
                        <RangeControl 
                            label={__('Blur Shadow(px)','spice-blocks')}			    
                            value={ blurshadow}
                            onChange={(userVal) => setAttributes({ blurshadow: userVal })}
                            min={0}
                            max={100}
                        />
                        <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                            title={__('Background & Color Settings','spice-blocks')}
                            colorSettings={[
                                {
                                    value: shadowColor,
                                    onChange: (colors) => setAttributes({ shadowColor: colors }),
                                    label: __('Box Shadow Color','spice-blocks')
                                },
                            ]}
                        />
                    </PanelBody>   
                    <PanelBody initialOpen={false} title={__('Color Settings','spice-block')} className={'spice-block-side-margin'}>
                        <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                            title={__('Background & Color Settings','spice-blocks')}
                            colorSettings={[
                                {
                                    value: titleColor,
                                    onChange: (colors) => setAttributes({ titleColor: colors }),
                                    label: __('Caption Color','spice-blocks')
                                },
                                {
                                    value: backgroundColor,
                                    onChange: (colors) => setAttributes({ backgroundColor: colors }),
                                    label: __('Overlay Color','spice-blocks')
                                }
                            ]}
                        />
                        <PanelBody>
                            <RangeControl 
                                label={__('Overlay Opacity','spice-blocks')}
                                value={overlayOpacity}
                                onChange={(onOverlayOpacityChange) =>
                                props.setAttributes({overlayOpacity:onOverlayOpacityChange})}
                                min={0}
                                max={1}
                                step={0.01}
                                help={ __( 'Change the overlay opacity for the background color.' ) }
                            />
                        </PanelBody>
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Typography','spice-blocks')} className={'spice-block-side-margin'}>
                            <SelectControl
                                label={__(' Font Family','spice-blocks')}
                                value={ titleFamily }
                                options={fontfamilylist}
                                onChange={ (newtext) => setAttributes({ titleFamily: newtext }) }
                            />                      
                        
                            <FontSizePicker 
                                __nextHasNoMarginBottom
                                value={ titleSize }
                                onChange={(userVal) => setAttributes({titleSize: userVal})}
                            />

                            <SelectControl
                                label={__('Font Weight','spice-blocks')}
                                options= {[
                                    { label: __('Thin','spice-blocks'), value: '100' },
                                    { label: __('Extra Light','spice-blocks'), value: '200' },
                                    { label: __('Light','spice-blocks'), value: '300' },
                                    { label: __('Regular','spice-blocks'), value: '400' },
                                    { label: __('Medium','spice-blocks'), value: '500' },
                                    { label: __('Semi Bold','spice-blocks'), value: '600' },
                                    { label: __('Bold','spice-blocks'), value: '700' },
                                    { label: __('Extra Bold','spice-blocks'), value: '800' },
                                    { label: __('Black','spice-blocks'), value: '900' }
                                ]}
                                value={titleWeight}
                                onChange={ (userVal) => setAttributes({ titleWeight: userVal }) }
                            />

                            <RangeControl 
                                label={__('line Height(px)','spice-blocks')}
                                value={titleHeight}
                                min={0}
                                max={100}
                                onChange={(userVal) => setAttributes({titleHeight: userVal})}
                            />

                            <SelectControl
                                label={__('Text Transform','spice-blocks')}
                                options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                    { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                    { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                                ]}
                                value={titleTransform}
                                onChange={(userVal) => setAttributes({titleTransform:userVal})}
                            />

                            <SelectControl 
                                label={__('Text Decoration','spice-blocks')}
                                options={[
                                    { label: __('Default','spice-blocks'), value: '' },
                                    { label: __('Underline','spice-blocks'), value: 'underline' },
                                    { label: __('Overline','spice-blocks'), value: 'overline' },
                                    { label: __('Line Through','spice-blocks'), value: 'line-through' }
                                ]}
                                value={titleDecoration}
                                onChange={(userVal) => setAttributes({titleDecoration:userVal})}
                            />

                            <RangeControl 
                                label={__('Letter Spacing','spice-blocks')}
                                value={titleLetterSpacing}
                                min={-10.0}
                                max={10.0}
                                onChange={(userVal)=> setAttributes({titleLetterSpacing:userVal})}
                            />
                    </PanelBody>
                    <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>
                </InspectorControls>    
                <style dangerouslySetInnerHTML={{
                         __html:[ 
                                `#spice-block-gallery-${uniqueId}{
                                    padding: ${sectionPaddings.top} ${sectionPaddings.right ? sectionPaddings.right : 'auto'} ${sectionPaddings.bottom} ${sectionPaddings.left ? sectionPaddings.left : 'auto'};
                                    margin: ${sectionMargin.top} ${sectionMargin.right} ${sectionMargin.bottom} ${sectionMargin.left};
                                }
                                #spice-block-gallery-${uniqueId}{ 
                                    gap:${gutterMargin + 'px'};
                                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                                    animation-delay: ${delay}ms;
                                }
                                #spice-block-gallery-${uniqueId}.spice-block-col-1{ grid-template-columns: repeat(auto-fit, 95%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-2{ grid-template-columns: repeat(auto-fit, 47%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-3{ grid-template-columns: repeat(auto-fit, 30%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-4{ grid-template-columns: repeat(auto-fit, 22%);}
                                #spice-block-gallery-${uniqueId} figure{
                                    margin: 0;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img img{
                                    border-radius:${imageBorderRadius + '%'};
                                    height:100%;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:before{
                                    border-radius:${imageBorderRadius + '%'};
                                }
                                #spice-block-gallery-${uniqueId}  .gallery-img figcaption .img-caption h4{
                                    color: ${titleColor};
                                    font-size: ${titleSize};
                                    font-family:${titleFamily ? titleFamily : 'Montserrat, sans-serif'};
                                    font-weight: ${titleWeight};
                                    text-decoration: ${titleDecoration};
                                    text-transform: ${titleTransform};
                                    letter-spacing: ${titleLetterSpacing}px;
                                    line-height: ${titleHeight}px;
                                    padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                                    text-align: ${alignment};
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:before{
                                    background-color: ${backgroundColor};
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:hover:before{
                                    opacity: ${overlayOpacity};
                                }
                                ${customcss}`
                                ].join('\n')
                            }}>
                </style>
                { hasImages && [
                        <div className={`spice-block-img-gallery spice-block-col-${colLayout} ${animationclass} ${displayclass} ${addclass}`} id={`spice-block-gallery-${uniqueId}`} tyle={{ animationDelay: delay+ 'ms'}}>
                            {props.attributes.images.map((image, index) => (     
                            <figure class="gallery-img">
                                <img key={index} src={image.url} alt={image.alt} data-id={ image.id } data-link={ image.link } id={uniqueId} />
                                <figcaption>
                                    <div class="img-caption">
                                        {displayCaption && (<>
                                        <h4>{image.caption}</h4>
                                        </>)}
                                    </div>
                                </figcaption>
                            </figure>
                            ))}
                        </div>
                ]}
                {! hasImages && [
                    <MediaPlaceholder
                            multiple
                            gallery
                            addToGallery={true}
                            icon={<BlockIcon icon="format-gallery" />}
                            onSelect={(newImages) => props.setAttributes({ images: newImages })}
                            allowedTypes={["image"]}
                            value={props.attributes.images.map((image) => image.id)}
                            labels={{
                                title: "Create Gallery",
                                instructions: "Create an awesome gallery block."
                            }}
                        />
                ]}
                <BlockControls>
                        <ToolbarGroup>
                            <MediaUploadCheck>
                                <MediaUpload
                                    multiple
                                    gallery
                                    addToGallery={true}
                                    onSelect={(newImages) =>  props.setAttributes({ images: newImages })}
                                    allowedTypes={["image"]}
                                    value={props.attributes.images.map((image) => image.id)}
                                    render={({ open }) => (<ToolbarButton onClick={open}>{__("Edit Gallery", "Create Gallery")}</ToolbarButton>)}
                                />
                            </MediaUploadCheck>
                        </ToolbarGroup>
                        <AlignmentToolbar
                            value={attributes.alignment}
                            onChange={(newalign) => setAttributes({ alignment: newalign })}
                        />	
                </BlockControls>    
                    </>] )
    },
    save: function({attributes}){
            const { uniqueId, colLayout, gutterMargin, imageBorderRadius, sectionMargin, titlePaddings, sectionPaddings, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, titleColor, backgroundColor, shadowColor, overlayOpacity, titleSize, titleFamily, titleWeight, titleHeight, titleTransform, titleDecoration, titleLetterSpacing, displayCaption, alignment, addclass, customcss} = attributes;
            const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
            const displaydesktop=(hidedesktop == false) ? 'gallery-hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'gallery-hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'gallery-hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
            return(<>
                    <script>
                        var titleFamily=`{titleFamily}`;
                        var url = 'https://fonts.googleapis.com/css2?family='+titleFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                        var link = document.createElement('link');
                        link.href = url;
                        link.rel = "stylesheet";
                        link.type =  "text/css";	          
                        document.head.appendChild(link);
                    </script>
                    <style dangerouslySetInnerHTML={{
                            __html:[ 
                                `#spice-block-gallery-${uniqueId}{
                                    padding: ${sectionPaddings.top} ${sectionPaddings.right} ${sectionPaddings.bottom} ${sectionPaddings.left};
                                    margin: ${sectionMargin.top} ${sectionMargin.right ? sectionMargin.right : 'auto'} ${sectionMargin.bottom} ${sectionMargin.left ? sectionMargin.left : 'auto'};
                                    gap:${gutterMargin + 'px'};
                                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                                    animation-delay: ${delay}ms;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img figcaption .img-caption h4{
                                    padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                                    text-align: ${alignment};
                                }
                                #spice-block-gallery-${uniqueId}.spice-block-col-1{ grid-template-columns: repeat(auto-fit, 95%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-2{ grid-template-columns: repeat(auto-fit, 45%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-3{ grid-template-columns: repeat(auto-fit, 30%);}
                                #spice-block-gallery-${uniqueId}.spice-block-col-4{ grid-template-columns: repeat(auto-fit, 20%);}
                                #spice-block-gallery-${uniqueId} figure{
                                    margin: 0;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img img{
                                    border-radius:${imageBorderRadius + '%'};
                                    height:100%;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:before{
                                    border-radius:${imageBorderRadius + '%'};
                                }
                                #spice-block-gallery-${uniqueId}  .gallery-img figcaption .img-caption h4{
                                    color: ${titleColor};
                                    font-size: ${titleSize};
                                    font-family:${titleFamily};
                                    font-weight: ${titleWeight};
                                    text-decoration: ${titleDecoration};
                                    text-transform: ${titleTransform};
                                    letter-spacing: ${titleLetterSpacing}px;
                                    line-height: ${titleHeight}px;
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:before{
                                    background-color: ${backgroundColor};
                                }
                                #spice-block-gallery-${uniqueId} .gallery-img:hover:before{
                                    opacity: ${overlayOpacity};
                                }
                                @media (max-width:768px){
                                    body #spice-block-gallery-${uniqueId}.spice-block-img-gallery {
                                        grid-template-columns: repeat(auto-fit, 95%);
                                    }
                                    .spice-block-img-gallery .gallery-img figcaption {max-width: unset;}
                                }
                               ${customcss} `
                            ].join('\n')
                        }}>
                    </style>
                    <div className={`spice-block-img-gallery front-view spice-block-col-${colLayout} ${animationclass} ${displayclass}  ${attributes.className} ${addclass}`} id={`spice-block-gallery-${uniqueId}`} tyle={{ animationDelay: delay+ 'ms'}}>
                            {attributes.images.map((image, index) => (     
                            <figure class="gallery-img">
                                <img key={index} src={image.url} alt={image.alt} data-id={ image.id } data-link={ image.link } id={uniqueId} />
                                <figcaption>
                                    <div class="img-caption">
                                        {displayCaption && (<>
                                        <h4>{image.caption}</h4>
                                        </>)}
                                    </div>
                                </figcaption>
                            </figure>
                            ))}
                        </div>
                    </>)
    }
})